import { ReactNode } from 'react';
import ViewingMode from 'shared/components/viewing-mode-controller/types/viewing-mode';

import WanderingBoundaryPassage from 'features/wandering-boundary-settings/domain/models/wandering-boundary-passage';
import WanderingBoundaryPassageRowProviderContext from 'features/wandering-boundary-settings/providers/contexts/wandering-boundary-passage-row-provider-context';
import useWanderingBoundaryPassageRowProviderState from 'features/wandering-boundary-settings/providers/states/wandering-boundary-passage-row-provider-state';

type Props = {
  children: ReactNode;
  wanderingBoundaryPassage: WanderingBoundaryPassage;
  viewingMode: ViewingMode;
};

const WanderingBoundaryPassageRowProvider = ({ children, wanderingBoundaryPassage, viewingMode }: Props): React.JSX.Element => (
  <WanderingBoundaryPassageRowProviderContext.Provider
    value={useWanderingBoundaryPassageRowProviderState(wanderingBoundaryPassage, viewingMode)}
  >
    {children}
  </WanderingBoundaryPassageRowProviderContext.Provider>
);

export default WanderingBoundaryPassageRowProvider;
